import Alias from "./Alias";

export default Alias;
